import {
  // CREATE_COMPANY,
  // GET_COMPANIES,
  // EDIT_COMPANY,
  // DELETE_COMPANY,
  ADD_COMPANY_SUCCESS,
  ADD_COMPANY_FAIL,
  DELETE_COMPANY_SUCCESS,
  DELETE_COMPANY_FAIL,
  GET_COMPANY_WITH_COMP_ID_SUCCESS,
  GET_COMPANY_WITH_COMP_ID_FAIL,
  GET_ALL_COMPANIES_SUCCESSFLL,
  GET_ALL_COMPANIES_FAIL,
  CLEAR_STATE,
} from "../Action/company";

const initialState = {
  companies: [],
  singleCompany: [],

  addCompanySuccess: "",
  addCompanyFail: "",

  deleteCompanySuccess: "",
  deleteCompanyFail: "",

  singleCompanyFetchedSuccess: "",
  singleCompanyFetchedFail: "",

  getCompaniesSuccessfull: "",
  getCompaniesFail: "",
};

function accountReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_COMPANY_SUCCESS: {
      let { result, message } = action.payload;
      return {
        ...state,
        companies: [...state.companies, result],
        addCompanySuccess: message,
      };
    }
    case ADD_COMPANY_FAIL: {
      return { ...state, addCompanyFail: action.payload };
    }

    case DELETE_COMPANY_SUCCESS: {
      let { message } = action.payload;
      return { ...state, deleteCompanySuccess: message };
    }
    case DELETE_COMPANY_FAIL: {
      return { ...state, deleteCompanyFail: action.payload };
    }
    case GET_ALL_COMPANIES_SUCCESSFLL: {
      let { result } = action.payload;
      return {
        ...state,
        getCompaniesSuccessfull: "companies fetched successfully",
        companies: result,
      };
    }

    case GET_ALL_COMPANIES_FAIL: {
      return {
        ...state,
        getCompaniesFail: action.payload,
      };
    }

    case GET_COMPANY_WITH_COMP_ID_SUCCESS: {
      let { result } = action.payload;
      return {
        ...state,
        singleCompanyFetchedSuccess: "Single company fetched successfully",
        singleCompany: result,
      };
    }
    case GET_COMPANY_WITH_COMP_ID_FAIL: {
      return { ...state, singleCompanyFetchedFail: action.payload };
    }
    // case DELETE_COMPANY: {
    //   console.log(action.payload);
    //   const after_delete_company = state.company.filter(
    //     (company) => company.id !== action.payload.id
    //   );
    //   console.log(after_delete_company);
    //   return { ...state, companies: after_delete_company };
    // }
    // case EDIT_COMPANY: {
    //   let UpdatedCompanies = state.company.map((item) =>
    //     item.id === action.payload.id ? action.payload : item
    //   );
    //   return {
    //     ...state,
    //     company: UpdatedCompanies,
    //   };
    // }

    case CLEAR_STATE: {
      return {
        ...state,

        addCompanySuccess: "",
        addCompanyFail: "",

        singleCompanyFetchedSuccess: "",
        singleCompanyFetchedFail: "",

        getCompaniesSuccessfull: "",
        getCompaniesFail: "",

        deleteCompanySuccess: "",
        deleteCompanyFail: "",
      };
    }

    default:
      return state;
  }
}

export default accountReducer;
